import { AimsCommonPopupEditorComponent, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions } from '@aims/common-components';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { HrEmployees } from 'src/models';
import { TransferHttpService, CacheItem } from '../../../services/transfer-http/transfer-http.service';
import { RevokeCommentDialogComponent } from '../training/revoke-comment-dialog/revoke-comment-dialog.component'; 

export enum ShowValue {
  MyWorkSection,
  MyDept,
  AllDepts
}

@Component({
  selector: 'app-certification-queue-base',
  template: `
    <p>
      certification-queue-base works!
    </p>
  `,
  styles: [
  ]
})
export class CertificationQueueBaseComponent implements OnInit {

  constructor(public transferHttp: TransferHttpService,
              public dialog: MatDialog) { }

  public trainingTaskHistory: Observable<Array<any>>;
  user = this.transferHttp.getCache<HrEmployees>('user');
  empId = this.user.employeeId;

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = true;

  routedFrom = 'selfTrainedCert';
  showValue: BehaviorSubject<ShowValue> = new BehaviorSubject(0);

  revokeCommentTxt: string = null;
  sendRevokeEmail: boolean = false;

  qId: number = 0;
  qthId: number = 0;
  qthDesc: string = null;
  qthLoginName: string = null;
  rowIndex: number = null;

  employeeValues = this.transferHttp.getCache(CacheItem.allEmployees);
  workSectionValues = this.transferHttp.getHot('Common/GetAllWorksectionsForDropdown');

  public tablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false,
  };

   public tableHeader: AimsCommonTableHeader[] = [
    { key: 'button', label: '', type: 'dynamic', filter: false, width: 75 },
    { key: 'employee', label: 'Employee', type: AimsCommonTableHeaderType.STRING },
    { key: 'qtDesc', label: 'Qual Task Desc', type: AimsCommonTableHeaderType.STRING },
    { key: 'intervalInMonths', label: 'Interval', type: AimsCommonTableHeaderType.NUMBER },
    { key: 'hazwoper', label: 'HAZWOPER', type: AimsCommonTableHeaderType.BOOLEAN, width: 80 },
    { key: 'completedOn', label: 'Completed On', type: AimsCommonTableHeaderType.DATE },
    { key: 'trainedBy', label: 'Trained By', type: AimsCommonTableHeaderType.STRING },
    { key: 'qtWsOwner', label: 'Work Section Owner', type: AimsCommonTableHeaderType.STRING },
  ];

  //Revoke Comment
  public openRevokeComment(trainingHistory: any, rowIndex: number) {
    this.rowIndex = rowIndex;
    this.qId = trainingHistory.qualId;
    this.qthId = trainingHistory.qtHistoryId;
    this.qthDesc = trainingHistory.qtDesc;
    this.qthLoginName = trainingHistory.loginName;

    this.sendRevokeEmail = true;

    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
      data: {
        header: '',
        content: RevokeCommentDialogComponent,
        contentData: { qthDesc : this.qthDesc,
                     },
      },
      disableClose: true,
    })

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.revokeCommentTxt = dialogResult.revokeComment;
        this.sendRevokeEmail = dialogResult.sendRevokeEmail;

        this.doRevoke();
      }
      else {
        this.cancelRevokeComment();
      }
    });

  }

  public cancelRevokeComment() {
    this.revokeCommentTxt = null;
  }

  public doRevoke() {
    let today = new Date();
    let revokedOn = today.toDateString();
    let revokedBy = this.user.fullName;
    this.spinnerText = "Revoking...";
    this.showSpinner = true;

    this.transferHttp.get(`Tr/RevokeTraining?qId=${this.qId}&qthId=${this.qthId}&revokedReason=${this.revokeCommentTxt}`).subscribe(retVal => {
      if (this.sendRevokeEmail) {
        this.transferHttp.get(`Tr/SendRevokeEmail?desc=${escape(this.qthDesc)}&revokedOn=${revokedOn}&revokedBy=${revokedBy}&revokedReason=${this.revokeCommentTxt}&loginName=${this.qthLoginName}`).subscribe();
      }
      this.refreshData();

      this.showSpinner = false;
    });

    this.revokeCommentTxt = null;
  }

  public certifyTraining(qtHistoryId: number, rowIndex: number) {
    this.spinnerText = "Certifying Qual Task...";
    this.showSpinner = true;

    this.transferHttp.get(`Tr/CertifyTraining?qtHistoryId=${qtHistoryId}`).subscribe(retVal => {
      this.refreshData();
      this.showSpinner = false;
    });
  }

  refreshData() {
  }

  ngOnInit(): void {
  }

}
